/**
 * safeUUID — RFC 4122 v4 UUID 발급.
 *
 * - Secure Context (HTTPS / localhost): `crypto.randomUUID()` 사용.
 * - 비-Secure Context (HTTP IP / file:): Math.random 기반 v4 fallback.
 *
 * 본 함수의 사용처는 외부에 노출되지 않는 세션 식별자 (SendHelper.nineMailId,
 * SignatureEdit signatureNineMailId) — 충돌 무해. production 브라우저의 HTTP context 에서
 * `crypto.randomUUID` 가 throw 하는 경우에만 fallback 분기가 의미를 가진다.
 */
export function safeUUID(): string {
  const cryptoObj = globalThis.crypto as Crypto | undefined
  if (cryptoObj?.randomUUID != null) {
    try {
      return cryptoObj.randomUUID()
    } catch {
      // Secure Context 위반 등 — fallback.
    }
  }
  // RFC 4122 v4 fallback. xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx (y ∈ 8/9/a/b).
  const hex = '0123456789abcdef'
  const chars = new Array<string>(36)
  for (let i = 0; i < 36; i++) {
    if (i === 8 || i === 13 || i === 18 || i === 23) {
      chars[i] = '-'
    } else if (i === 14) {
      chars[i] = '4'
    } else if (i === 19) {
      chars[i] = hex[8 + Math.floor(Math.random() * 4)]
    } else {
      chars[i] = hex[Math.floor(Math.random() * 16)]
    }
  }
  return chars.join('')
}
